import * as React from "react";

const SvgComponent = ({ width = "6px", height = "24px", color = "#636F7C", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 6 24"
    fill="none"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.55 2.593c0 1.431-1.12 2.592-2.5 2.592S.55 4.025.55 2.593C.55 1.16 1.67 0 3.05 0s2.5 1.16 2.5 2.593Zm0 9.166c0 1.432-1.12 2.593-2.5 2.593s-2.5-1.16-2.5-2.593c0-1.432 1.12-2.592 2.5-2.592s2.5 1.16 2.5 2.592Zm0 9.167c0 1.432-1.12 2.593-2.5 2.593s-2.5-1.161-2.5-2.593 1.12-2.593 2.5-2.593 2.5 1.161 2.5 2.593Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;